import apiService from "./apiService";
import { API_ROUTES } from "../config/apiRoutes";
import type { ApiResponse, PaginatedResponse } from "../types/api.types";
import type { Notification } from "../types/notifications";
import { assertApiSuccess, unwrapApiList } from "../utils/apiResponse";

interface NotificationDto extends Omit<Notification, "createdAt"> {
  created_at?: string;
  createdAt?: string;
}

const toNotification = (notification: NotificationDto): Notification => ({
  ...notification,
  createdAt: new Date(
    notification.created_at || notification.createdAt || Date.now(),
  ),
});

class SystemNotificationService {
  private activeListRequest: Promise<Notification[]> | null = null;

  async getNotifications(): Promise<Notification[]> {
    if (!this.activeListRequest) {
      this.activeListRequest = apiService
        .get<ApiResponse<NotificationDto[] | PaginatedResponse<NotificationDto>>>(
          API_ROUTES.SYSTEM_NOTIFICATIONS.BASE,
        )
        .then((response) => unwrapApiList(response).map(toNotification))
        .finally(() => {
          this.activeListRequest = null;
        });
    }

    return this.activeListRequest;
  }

  async markAsRead(notificationId: string): Promise<void> {
    const response = await apiService.patch<ApiResponse<unknown>>(
      API_ROUTES.SYSTEM_NOTIFICATIONS.MARK_AS_READ(notificationId),
    );
    assertApiSuccess(response);
  }

  async markAllAsRead(): Promise<void> {
    const response = await apiService.patch<ApiResponse<unknown>>(
      API_ROUTES.SYSTEM_NOTIFICATIONS.MARK_ALL_AS_READ,
    );
    assertApiSuccess(response);
  }

  async deleteNotification(notificationId: string): Promise<void> {
    const response = await apiService.delete<ApiResponse<unknown>>(
      API_ROUTES.SYSTEM_NOTIFICATIONS.DELETE(notificationId),
    );
    assertApiSuccess(response);
  }
}

export default new SystemNotificationService();
